import * as types from '../types';

const initialState = {
  policy: null,
  isFetching: false,
  errors: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_PROCESS_DETAILS:
      return {
        ...state,
        isFetching: true,
        errors: []
      };

    case types.FETCH_PROCESS_SUCCEEDED:
      return {
        ...state,
        policy: action.payload,
        isFetching: false,
        errors: []
      };

    case types.UPDATE_PROCESS:
      return {
        ...state,
        policy: action.payload
      };

    case types.FETCH_PROCESS_FAILED:
      return {
        ...state,
        errors: action.payload,
        isFetching: false
      };

    default:
      return state;
  }
};
